import { render, staticRenderFns } from "./talk.vue?vue&type=template&id=de1a1470&scoped=true"
import script from "./talk.vue?vue&type=script&lang=js"
export * from "./talk.vue?vue&type=script&lang=js"
import style0 from "./talk.vue?vue&type=style&index=0&id=de1a1470&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1a1470",
  null
  
)

export default component.exports